<template lang="html">
<!-- eslint-disable -->
<img
  :src="require('images/logo-full.svg')"
  alt='AcreTrader Company Logo'
  width="100%"
  height="100%"
/>
</template>

<script>
export default {
  name: 'TheHeaderLogoSvg',
  /* eslint-disable */
};
</script>
